// Scroll animation utility
export const initScrollAnimations = () => {
  // Use setTimeout to ensure DOM is ready after route change
  setTimeout(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Observe all elements with scroll-fade-in class
    document.querySelectorAll('.scroll-fade-in').forEach((el) => {
      observer.observe(el);
    });
  }, 100);

  return null;
};

